/** Synchronized with the Prisma enums of the same name. */
export const MANUAL_IMPORT_STATUSES = [
  'PENDING',
  'EXTRACTING',
  'COMPLETED',
  'FAILED',
  'CONFIRMED',
  'DISCARDED',
  'SUBMITTED',
] as const;
export type ManualImportStatus = (typeof MANUAL_IMPORT_STATUSES)[number];

export const LEGACY_REVIEW_STATUSES = ['PENDING', 'COMPLETED', 'FAILED', 'SKIPPED'] as const;
export type LegacyReviewStatus = (typeof LEGACY_REVIEW_STATUSES)[number];

/** Statuses that count as "the one active import" per tenant + template. */
export const ACTIVE_MANUAL_IMPORT_STATUSES: readonly ManualImportStatus[] = [
  'PENDING',
  'EXTRACTING',
  'COMPLETED',
  'CONFIRMED',
];

export const IMPORTED_ANSWER_CONFIDENCES = ['high', 'low'] as const;
export type ImportedAnswerConfidence = (typeof IMPORTED_ANSWER_CONFIDENCES)[number];
